import React from 'react';
import { StyledAdminPilotPage } from './pilotPage.style';
import parse from 'html-react-parser';
import { ErrorIcon } from '../errorBox/errorBox.style';

export interface IPilotPageProps {
  content: string;
};

const AdminPilotPage = (props: IPilotPageProps) => {
  const { content } = props;

  return (
    <>
      <StyledAdminPilotPage>
        <div>
          <ErrorIcon/>
        </div>
        { !!content ? parse(content) : <></>}
      </StyledAdminPilotPage>
    </>
  )
};

export const defaultProps: IPilotPageProps = {
  content: "Something went wrong!"
};

AdminPilotPage.defaultProps = defaultProps;

export default AdminPilotPage;